/** Vibecode authoring notes for `field-row` nodes (empty = omit from LLM bundle). */
export const FIELD_ROW_VIBECODE = [
  '`field-row`: `label[]` above `controls[]`; `hideLabel:true` on controls when row carries prompt.',
  'Multiselect prefix duplication: short copy in `label[]`, `optionLabelClassName:"hidden"` on option.',
].join('\n');
